<template>
    <main class="c-app-content is-sidebar-tiny">
    <comment type="post" target_id="0" :isAll='true'/>
    </main>
</template>

<script>
    import Comment from '@/components/comment/Comment';
    export default {
        components: {Comment},
    }
</script>